import moment, { type Moment } from 'moment';
import React, { useEffect, useState } from 'react';
import type { RouteComponentProps } from 'react-router-dom';

import useTitle from 'hooks/useTitle';

import * as routes from 'constants/routes';

import * as eventService from 'services/events';

import history from 'utils/history';
import { handleError } from 'utils/errorHandler';

import EventForm from './EventForm';
import BackButton from 'components/common/button/BackButton';
import Loading from 'components/common/loading/Loading';

type EventRouteParams = {
  id?: string;
};

type EventRecord = {
  id: number;
  name: string;
  description: string | null;
  link: string | null;
  eventDate: Moment;
};

const CreateEditEvent: React.FC<RouteComponentProps<EventRouteParams>> = (props) => {
  const eventId = props.match.params?.id;
  const title = eventId ? 'Edit Event' : 'Add Event';
  const setTitle = useTitle();

  useEffect(() => {
    setTitle(title);
  }, [setTitle, title]);

  const [loading, setLoading] = useState(Boolean(eventId));
  const [event, setEvent] = useState<EventRecord | null>(null);

  useEffect(() => {
    if (!eventId) {
      return;
    }

    const fetchEvent = async () => {
      try {
        const { data } = (await eventService.fetchEventById(eventId)) as {
          data: Omit<EventRecord, 'eventDate'> & { eventDate: string };
        };
        setEvent({
          ...data,
          description: data.description ?? null,
          eventDate: moment(data.eventDate),
          link: data.link ?? null,
        });
      } catch (err) {
        handleError(err);
        history.push(routes.EVENTS);
      } finally {
        setLoading(false);
      }
    };

    void fetchEvent();
  }, [eventId]);

  return (
    <div className="full-scope-card">
      <div className="full-scope-card__header table-header name-wrap">
        <div className="d-flex flex-row">
          <BackButton />
          <div className="d-flex flex-row">
            <div className="table-header">
              <h3 className="text-bold">{title}</h3>
            </div>
          </div>
        </div>
      </div>
      {loading ? (
        <div className="loading-min-height">
          <Loading />
        </div>
      ) : (
        <EventForm event={event} />
      )}
    </div>
  );
};

export default CreateEditEvent;
